export const componentConfigThemeKey = 'sportradar';

export interface SportradarThemeProps {
  titleColor: string;
  backgroundColor: string;
}
